<template>
  <div
    :class="{'fade-in':form.email, 'iphone-100vh': false}"
    class="container-fluid profile profile-row"
  >
    <div class="row">
      <div class="col-xl-6 col-12 pl-0 custom-pr">
        <div class="col-12 card card-body">
          <General
            ref="editProfile"
            v-model:user="user"
            v-model:form="form"
            :btn-disable="!user"
            :class="{wavebg: loading}"
          />

          <hr>

          <PaymentMethod
            v-model:user="user"
            v-model:form="form"
            :btn-disable="!user"
            :class="{wavebg: loading}"
          />

          <hr>

          <EditSecondFactor
            v-model:user="user"
            v-model:form="form"
            :btn-disable="!user"
            :class="{wavebg: loading}"
          />
        </div>
      </div>
      <div class="col-xl-6 col-12 pl-0 pr-0 custom-pr">
        <div
          v-if="user.is_public_profile_enabled"
          class="col-12 p-0 custom-mt-respons"
        >
          <PublicProfile v-model:public-profile-data="user.public_profile" />
        </div>
        <div
          class="col-12 p-0"
          :class="{ 'mt-16': user.is_public_profile_enabled }"
        >
          <EditNotifications
            :class="{wavebg: loading}"
            :channel-value="channel"
            :turnon-value="turnon"
          />
        </div>
      </div>
    </div>
    <ApiKeys
      :class="{wavebg: loading}"
      :btn-disable="!user"
      :passed-params="passedParams"
    />
  </div>
</template>

<script>
import eventBus from '@/lib/eventBus';
import HelpersMixin from '@/components/Helpers/helpers-mixin';
import { cloneDeep } from '@/lib/lodash';
import General from './Profile/General.vue';
import PaymentMethod from './Profile/PaymentMethod.vue';
import EditSecondFactor from './Profile/EditSecondFactor.vue';
import EditNotifications from './Profile/EditNotifications.vue';
import PublicProfile from './Profile/PublicProfile.vue';
import ApiKeys from './Profile/ApiKeys.vue';


const fetch = (ctx) => ctx.$store.dispatch('getProfileData');

export default {
  name: 'Profile',
  fetch,
  components: {
    General,
    PaymentMethod,
    EditSecondFactor,
    EditNotifications,
    PublicProfile,
    ApiKeys,
  },
  props: ['fetchedData', 'passedParams'],
  mixins: [
    HelpersMixin,
  ],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.profile.user;
    },
    firstDay() {
      return this.$store.state.profile.user.first_day_of_week;
    },
    channel() {
      return this.$store.getters.getUser.service_domain_changes_notifications_channel;
    },
    turnon() {
      return this.$store.getters.getUser.service_domain_changes_notifications_enabled;
    },
    form() {
      const { user } = this.$store.state.profile;

      return cloneDeep({
        ...user,
        ...((!user.date_of_birth || user.date_of_birth === 'Invalid date') && {
          date_of_birth: this.$t('profile.generalInfo.notSpecified'),
        }),
      });
    },
  },
  mounted() {
    eventBus.$on('window-refresh', () => {
      if (this.$route.name === 'routes.profile') {
        this.loading = true;
        fetch(this)
          .then(() => {
            this.afterBrowserRedraw(() => {
              this.loading = false;
            });
          });
      }
    });
  },
  activated() {
    this.loading = true;
    fetch(this)
      .then(() => {
        this.afterBrowserRedraw(() => {
          this.loading = false;
        });
      });
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/profile/profile';

.card-body {
  @media (max-width: 650px) {
    padding: 16px !important;
  }
}
</style>
<style lang="scss">
.profile {
  .form-group.red-border {
    input[type='text'], input[type='password'] {
      border: 1px solid #ff5c70 !important;
    }
  }

  @media (max-width: 650px) {
    .card-title {
      font-size: 14px !important;
    }
  }
}
</style>
